import React from "react";
import './MarksPanelRight.css'
const infoSvg = (
  <svg
    style={{ fill: "#0076BD" }}
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
  >
    <path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z"></path>
  </svg>
);

const externalLinkSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="#0076BD"
  >
    <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z"></path>
  </svg>
);


const MarksPanelRight = ({
  onSubmitMarks,
  onSubmitEvidence,
  onViewReports,
}) => (
  <div className="column">
    {/* --- NEW CARD: Total marks submission --- */}
    <div className="card has-background-white-ter mb-5">
      <div className="card-content">
        <strong>Submit total marks for all candidates</strong>
        <div className="my-4 is-flex">
          <span className="icon mr-2">{infoSvg}</span>
          <p>The deadline is 10 working days before your visit.</p>
        </div>
        <div style={{ height: "8px" }} />
        <button
          className="button is-primary is-outlined"
          onClick={() => onSubmitMarks('submitmarks')}
          type="button"
        >
          Submit total marks
        </button>
      </div>
    </div>

    {/* --- NEW CARD: Assessment criteria marks submission --- */}
    <div className="card has-background-white-ter mb-5">
      <div className="card-content">
        <strong>View your sample candidates and submit criteria marks</strong>
        <div className="my-4 is-flex">
          <span className="icon mr-2">{infoSvg}</span>
          <p>The deadline for submitting criteria marks for the sample is at least 3 working days before your visit.</p>
        </div>
        <div style={{ height: "8px" }} />
        <button className="button is-primary is-outlined" type="button" onClick={ () => onSubmitMarks('submitAssessmentcriteria')}>
          Submit assessment criteria marks
        </button>
      </div>
    </div>

    <div className="card has-background-white-ter mb-5">
      <div className="card-content">
        <strong>Submit evidence for moderation</strong>
        <div className="my-4 is-flex">
          <span className="icon mr-2">{infoSvg}</span>
          <p>
            You will need to submit evidence for the sample using our Submit for Assessment service at least 3 working days before your visit.
          </p>
        </div>
        <button
          className="button is-primary is-outlined"
          onClick={onSubmitEvidence}
        >
          Submit for Assessment
          <span className="icon ml-2 inherit-color">{externalLinkSvg}</span>
        </button>
      </div>
    </div>

    <div className="card has-background-white-ter">
      <div className="card-content">
        <strong>View moderation reports</strong>
        <div className="my-4 is-flex">
          <span className="icon mr-2">{infoSvg}</span>
          <p>Moderation reports will be available approximately 10 days after your visit.
 </p>
        </div>
        <button
          className="button is-primary is-outlined"
          onClick={onViewReports}
        >
          View reports
        </button>
      </div>
    </div>
  </div>
);

export default MarksPanelRight;
